import Vue from "vue";

import ViewListIcon from "vue-material-design-icons/ViewList.vue";
import PencilIcon from "vue-material-design-icons/Pencil.vue";

// Register the Icons so Webpack includes them and we can use them
Vue.component("ViewListIcon", ViewListIcon);
Vue.component("PencilIcon", PencilIcon);

export default [
  {
    name: "Document",
    children: [
      {
        icon: "view-list",
        title: "Library",
        to: { name: "library.list", query: { limit: 20, filter: "library" } },
        loggedIn: true,
      },
      {
        icon: "view-list",
        title: "List Document",
        to: { name: "document.list", query: { limit: 10, filter: "all" } },
        loggedIn: true,
      },
      {
        icon: "pencil",
        title: "New Document",
        to: { name: "document.create" },
        loggedIn: true,
      },
    ],
    loggedIn: true,
  },
  {
    name: "Document Read",
    children: [
      {
        icon: "view-list",
        title: "List Document Read",
        to: { name: "document_read.list", query: { limit: 10, filter: "all" } },
        loggedIn: true,
      },
      // {
      //   icon: "pencil",
      //   title: "New Document Read",
      //   to: { name: "document_read.create" },
      //   loggedIn: true,
      // },
    ],
    loggedIn: true,
  },
  {
    name: "DMS Manage",
    children: [
      {
        icon: "view-list",
        title: "List Document Category",
        to: {
          name: "document_category.list",
          query: { limit: 25, filter: "active", sort: "description" },
        },
        loggedIn: true,
      },
      {
        icon: "view-list",
        title: "List Document Type",
        to: {
          name: "code_document_type.list",
          query: { limit: 25, filter: "active", sort: "description" },
        },
        loggedIn: true,
      },
    ],
    loggedIn: true,
  },
];
